//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "tri_line",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      console.log(self.form,11);
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false;
        return "...";
      } else {
        console.log(form,22);
        self.hasScore = true;
        let result = 0;
        result = 2.2 + 3.65 * (form.value1 + form.value2 + form.value3);

        return result.toFixed(2);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/tri_line.vue